module.exports = __webpack_public_path__ + "6e7c85cf979ab248810fded37b71aa11.pdf";